// extracted by mini-css-extract-plugin
export default {"video":"HomeBlocks_video__q0MY-"};